<template>
    <span
        v-b-tooltip.hover
        :title="$dayjs(modelValue).format('DD-MM-YYYY HH:mm:ss')"
    >
        {{ dateText }}
    </span>
</template>

<script>
export default {
    props: {
        modelValue: String,
    },
    data () {
        return {
            dateText: '',
            timer: {},
        };
    },
    created () {
        this.timer = setInterval(() => {
            this.calcDate();
        }, 30000);
        this.calcDate();
    },
    beforeUnmount () {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        calcDate () {
            this.dateText = this.modelValue ? this.$dayjs(this.modelValue).fromNow() : `(${this.$t('defaults.none').toLowerCase()})`;
        },
    },
};
</script>
